import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {StorageService} from '@core/services/storage.service';

export const AuthGuard: CanActivateFn = () => {
    const storageService = inject(StorageService);
    return storageService.isLogged() || inject(Router).navigate(["/login"]);
};